import { useRef } from 'react';
import GroupsInfiniteList from './groupsInfiniteList';
import FilterListGroups from '../utils/filterLists/filterListGroups';
import ListPageLayout from '../utils/ListPageLayout';

function GroupsPage() {
  const updateQueryFunc = useRef(null);

  function handleQuery(filters) {
    if (typeof updateQueryFunc.current === 'function') { updateQueryFunc.current(filters); }
  }

  return (
    <>
      <ListPageLayout
        title="Groups"
        tagline="Training and operational histories of Bomber, Fighter, Recon and Transport units."
        sidebar={<FilterListGroups isFiltered={handleQuery} />}
      >
        <GroupsInfiniteList filterQuery={updateQueryFunc} />
      </ListPageLayout>
    </>
  );
}

export default GroupsPage;
